import React, { type FC, type ReactNode, useState } from 'react';

import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Expander from '@amzn/meridian/expander';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

interface LimitationCardProps {
  duration?: number | null;
  frequency?: number | null;
  freeFormText?: string | null;
  cardHeader: ReactNode;
}

const LimitationCard: FC<LimitationCardProps> = ({ duration, frequency, freeFormText, cardHeader }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card spacingInset="100 500" minWidth="750px">
      {!!duration || !!frequency || !!freeFormText?.length ? (
        <Expander type="list" open={isOpen} onChange={setIsOpen} title={cardHeader}>
          <Row spacing="600" alignmentVertical="top">
            {!!duration && (
              <Column spacing="200">
                <Text color="secondary">Duration</Text>
                <Text>{duration} min</Text>
              </Column>
            )}

            {!!frequency && (
              <Column spacing="200">
                <Text color="secondary">Frequency per Shift</Text>
                <Text>{frequency}</Text>
              </Column>
            )}

            {!!freeFormText?.length && (
              <Column spacing="200">
                <Text color="secondary">Description</Text>
                <Text>{freeFormText}</Text>
              </Column>
            )}
          </Row>
        </Expander>
      ) : (
        <Row spacingInset="400 500">{cardHeader}</Row>
      )}
    </Card>
  );
};

export default LimitationCard;
